import React, { forwardRef } from 'react';
import T from 'prop-types';
import cx from 'classnames';

import Tooltip from '../Tooltip';

// eslint-disable-next-line prefer-arrow-callback
const NavigationTabs = forwardRef(function NavigationTabs({
  active,
  options,
  navTag = 'a',
  className,
  onChange,
}, ref) {
  return (
    <nav ref={ref} className={cx('navigation-tabs', className)}>
      {options.map(({
        label,
        value,
        href,
        disabled,
        notAllowed,
        tooltipContent,
      }) => {
        const isActive = active === value;
        const isSelectable = !isActive && !notAllowed && !disabled;

        const NavTag = isSelectable ? navTag : 'div';

        const withHref = NavTag === 'a' && !!href && isSelectable;

        return (
          <Tooltip
            key={value}
            id={`navigation-tab-tooltip--${value}`}
            content={tooltipContent}
          >
            <NavTag
              {...(withHref ? { href } : {})}
              className={cx('navigation-tabs__item', {
                active: isActive,
                disabled: disabled || notAllowed,
                selectable: isSelectable,
              })}
              data-value={value}
              onClick={() => isSelectable && onChange?.(value)}
            >
              <span data-title={label} className="navigation-tabs__item-label">
                {label}
              </span>
              {notAllowed && <span className="hicon-lock" />}
            </NavTag>
          </Tooltip>
        );
      })}
    </nav>
  );
});

NavigationTabs.propTypes = {
  active: T.string,
  options: T.arrayOf(T.shape({
    label: T.string.isRequired,
    value: T.string.isRequired,
    href: T.string,
    disabled: T.bool,
    notAllowed: T.bool,
    tooltipContent: T.string,
  })).isRequired,
  navTag: T.string,
  className: T.string,
  onChange: T.func,
};

export default NavigationTabs;
